// Router-link usa el slug para viajar a las rutas.
// isDisabled: true / false
// rule: indica qué roles son aceptados para mostrar este ítem en el navbar (vertical u horizontal)
//   si un rol no está indicado dentro del array, para los usuarios con dicho rol no se mostrará ese elemento.

export default [
  {
    url: '/',
    name: 'Dashboard',
    slug: 'dashboard',
    icon: 'BarChartIcon',
    isDisabled: false,
    rule: ['public', 'client', 'asesor', 'admin']  
  },
  {
    url: null,
    name: 'Extranjería',
    icon: 'FlagIcon',
    submenu: [
      {
        url: '/page2',
        name: 'Vista CLIENTE',
        slug: 'page223',
        icon: 'FlagIcon',
        isDisabled: false,
        rule: ['public', 'client', 'asesor', 'admin']
      },
      {
        url: '/admin/cliente/24',
        name: 'Ficha Interna Cliente',
        slug: 'Ficha Extranjería',
        icon: 'FlagIcon',
        isDisabled: false,
        rule: ['public', 'client', 'asesor', 'admin']
      }
    ]
  },
  {
    url: null,
    name: 'Usuarios',
    icon: 'UsersIcon',
    submenu: [
      {
        url: '/admin/empleados',
        name: 'Empleados',
        slug: 'admin.empleados',
        icon: 'UsersIcon',
        isDisabled: false,
        rule: ['asesor', 'admin']
      }, 
      {
        url: '/admin/clientes',
        name: 'Clientes',
        slug: 'admin.clientes',
        icon: 'UsersIcon',
        isDisabled: false,
        rule: ['asesor', 'admin']
      },
      {
        url: '/admin/asesores',
        name: 'Asignación Asesores',
        slug: 'admin.asesores',
        icon: 'UsersIcon',
        isDisabled: false,
        rule: ['asesor', 'admin']
      }
    ]
  },
  {
    url: null,
    name: 'Otros',
    icon: 'PaperclipIcon',
    submenu: [
      {
        url: '/admin/gestion-servicios',
        name: 'Gestión de Servicios',
        slug: 'admin.gestion-servicios',
        icon: 'PaperclipIcon',
        isDisabled: false,
        rule: ['asesor', 'admin']
      },
      {
        url: '/admin/pagos',
        name: 'Gestión de Pagos',
        slug: 'admin.pagos',
        icon: 'DollarSignIcon',
        isDisabled: false,
        rule: ['asesor', 'admin']
      }
    ]
  }
]
